export const kvkkSozlesmesi = {
  title: 'KVKK Sözleşmesi',
  sections: [
    {
      heading: 'Kişisel Verilerin Korunması Hakkında Bilgilendirme',
      paragraphs: [
        '6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") uyarınca, Yol SepetiGO Teknoloji olarak kişisel verilerinizi aşağıda açıklanan şekilde işlemekteyiz.',
      ],
    },
    {
      heading: 'İşlenen Kişisel Veriler',
      list: [
        'Kimlik bilgileri (ad, soyad, T.C. kimlik no)',
        'İletişim bilgileri (telefon, e-posta, adres)',
        'Konum verileri',
        'Finansal bilgiler (ödeme bilgileri)',
        'Araç bilgileri (plaka, marka, model)',
      ],
    },
    {
      heading: 'Verilerin Saklanma Süresi',
      paragraphs: [
        'Kişisel verileriniz, işleme amacının gerektirdiği süre boyunca ve yasal saklama süreleri dahilinde muhafaza edilmektedir.',
      ],
    },
    {
      heading: 'Veri Güvenliği',
      paragraphs: [
        'Kişisel verilerinizin güvenliği için teknik ve idari tedbirler alınmakta olup, yetkisiz erişim, kayıp ve kötüye kullanıma karşı koruma sağlanmaktadır.',
      ],
    },
    {
      heading: 'Başvuru Hakkı',
      paragraphs: [
        'KVKK kapsamındaki haklarınız için info@yolsepetigo.com adresine yazılı başvuruda bulunabilirsiniz.',
      ],
    },
  ],
};
